export default class Form {
    /**
     * constructor n a que des variable
     * @param {this} element - contient un element html
     * @param {this} formElements - contient tous les elements html du formulaire
     *
     */
  constructor(element) {
    this.element = element;
    this.formElements = this.element.elements;
    this.init();
  }

    /**
     * dans le init les elements html sont soit directement envoyer vers la validation ou si l on essaie de rendre le formulaire, il recupere de nouveau les elements et les envoit vers onSubmit
     * @param {type} name - description
     */
  init() {
    this.element.setAttribute('novalidate', '');

    for (let i = 0; i < this.formElements.length; i++) {
      const input = this.formElements[i];
      
      if (input.required) {
        input.addEventListener('input', this.validateInput.bind(this));
      }
    }
    this.element.addEventListener('submit', this.onSubmit.bind(this));
  }

    /**
     * onSubmit permet de recuperer les elements des que l on essaie de rendre le formulaire et envoie les elements se faire valide
     */
  onSubmit(event) {
    event.preventDefault();

    if (this.validate()) {
      console.log('success');
      this.showConfirmation();
    } else {
      console.log('error');
    }
  }

  
  /**
   * validate recoit tout les elements du form et les envoies vers la validation en les separant dans la boucle en element valide ou pas valide
   */
  validate() {
    let isValid = true;

    for (let i = 0; i < this.formElements.length; i++) {
      const input = this.formElements[i];

      if (input.required && !this.validateInput(input)) {
        isValid = false;
      }
    }
    return isValid;
  }

    /**
     * validateInput gere si un element est valide ou si il manque des informations pour ajouter ou enlever la classe d etat error
     * @param {const} input - recoit tout les elements html du formulaire    */
  validateInput(event) {
    const input = event.currentTarget || event

    if (input.validity.valid) {
      this.removeError(input);
    } else {
      this.addError(input);
    }

    return input.validity.valid;
  }

    /**
     * addError empoeche d envoyer le formulaire et ajoute une classe d etat sur les elements ou il maque des informations
     * @param {const} container - permet d identifier l element sur lequel il manque des informations pour ajouter la classe error
     */
  addError(input) {
    const container = input.closest('[data-input-container=""]') || input.closest('.input');
    container.classList.add('error');
  }


    /**
     * removeError permet de retirer les styles que la classe d etat error ajoute et qui ainsi permet d envoyer le formulaire
     * @param {const} container - permet d indentifier l element sur lequel on enleve l erreur
     */
  removeError(input) {
    const container = input.closest('[data-input-container=""]') || input.closest('.input');
    container.classList.remove('error');
  }


    /**
     * showConfirmation fait apparaitre le texte de validation comme quoi le formulaire est completer et envoyer
     * 
     */
  showConfirmation(){
    this.element.classList.add('is-sent');
  }
}
